import cx from 'classnames';
import PropTypes from 'prop-types';

const Body = ({ data }) => {
  const { spacing, showLine } = data;

  const classes = cx('block-divider', spacing, {
    line: showLine,
  });

  return <div className={classes}></div>;
};

Body.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),

  isEditMode: PropTypes.bool,
};

export default Body;
